// Browser-side helper: register the service worker, ask for notification
// permission, subscribe to push, send the subscription up to the server.

import { authedFetch } from "./supabase";

function urlBase64ToUint8Array(base64) {
  const padding = "=".repeat((4 - (base64.length % 4)) % 4);
  const b = (base64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b);
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

export async function enableWebPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Push not supported in this browser");
  }
  const reg = await navigator.serviceWorker.ready;
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notification permission denied");

  const r = await fetch("/api/notifications/vapid-public-key");
  const { publicKey } = await r.json();
  if (!publicKey) throw new Error("Server has no VAPID key");

  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicKey),
  });

  await authedFetch("/api/notifications/push/subscribe", {
    method: "POST",
    body: JSON.stringify({
      platform: "web",
      token: JSON.stringify(sub.toJSON()),
      userAgent: navigator.userAgent,
    }),
  });
  return true;
}
